<template>
    <modified-date-picker
        v-model="text"
        :name="name"
        :pick-time="pickTime"
        :format="format"
        :label="label"
        :is-date-disabled="isDateDisabled"
        :required="required"
        :next-month-caption="nextMonthCaption"
        :prev-month-caption="prevMonthCaption"
        :set-time-caption="setTimeCaption"
        :weekdays="weekdays"
        :months="months"
        @input="input"
    />
</template>

<script>
    import ModifiedDatePicker from './ModifiedDatePicker';

    export default {
        components: {
            ModifiedDatePicker,
        },
        props: {
            name: {
                required: true,
                type: String,
            },
            initialValue: {
                required: false,
                type: String,
                default: '',
            },
            pickTime: {
                required: false,
                type: Boolean,
                default: false,
            },
            label: {
                required: false,
                type: String,
                default: lang('Välj datum','Select date'),
            },
            min: {
                type: String,
                default: null,
            },
            max: {
                type: String,
                default: null,
            },
            required: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                text: this.initialValue,
                nextMonthCaption: 'Next month',
                prevMonthCaption: 'Previous month',
                setTimeCaption: 'Set time:',
                weekdays: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
                months: [
                    'January', 'February', 'March', 'April',
                    'May', 'June', 'July', 'August',
                    'September', 'October', 'November', 'December',
                ],
            };
        },
        computed: {
            format() {
                if (this.pickTime === true) {
                    return 'YYYY-MM-DD HH:mm';
                }

                return 'YYYY-MM-DD';
            },
        },
        created() {
            if (window.App.locale === 'sv') {
                this.nextMonthCaption = 'Nästa månad';
                this.prevMonthCaption = 'Föregående månad';
                this.setTimeCaption = 'Sätt tid:';
                this.weekdays = [
                    'Mån', 'Tis', 'Ons', 'Tor', 'Fre', 'Lör', 'Sön',
                ];
                this.months = [
                    'Januari', 'Februari', 'Mars', 'April',
                    'Maj', 'Juni', 'Juli', 'Augusti',
                    'September', 'Oktober', 'November', 'December',
                ];
            }
        },
        methods: {
            input() {
                this.$emit('input', this.text);
            },
            isDateDisabledByMinOrMax(date) {
                if (this.min && date < new Date(this.min)) {
                    return true;
                }

                if (this.max && date > new Date(this.max)) {
                    return true;
                }

                return false;
            },

            isDateDisabled(date) {
                return this.isDateDisabledByMinOrMax(date);
            },
        },
    };
</script>